import React from 'react'

export default function Terms() {
  return (
    <div style={{padding:'20px'}}>
        <h4 style={{textAlign:'center'}}>TERMS OF USE</h4>
        <p style={{fontSize:'16px'}}>
        1. Acceptance of Terms
By accessing or using the portal digital.definiteassurance.com (the “Portal”), you agree to comply
with and be bound by these Terms of Use. If you do not agree, please do not use the Portal. <br/>
2. Eligibility
The Portal is intended for use by customers, partners, employees, and authorized users of Definite
Assurance Company Ltd. By using the Portal, you confirm that you are at least 18 years old or
legally authorized to enter into binding agreements under applicable law.<br/>
3. User Accounts
To access certain services, you may be required to create an account. You are responsible for
maintaining the confidentiality of your login credentials and agree to notify us immediately of any
unauthorized access. Definite Assurance reserves the right to suspend or terminate accounts
misused or in violation of these Terms.<br/>
4. Permitted Use
You agree to use the Portal solely for lawful purposes, including accessing your insurance
information, paying premiums, submitting claims, and communicating with Definite Assurance. You
must not misuse the Portal or attempt unauthorized access.<br/>
5. Insurance-Specific Disclaimers
Policy information on the Portal is for convenience only; official policy documents prevail. Premium
payments are valid only upon confirmation and receipt issuance. Claims submissions are subject to
verification and IRA regulations.<br/>
6. Intellectual Property
All content on the Portal is the property of Definite Assurance Company Ltd or its licensors.
Unauthorized reproduction or distribution is prohibited.<br/>
7. Privacy
Use of the Portal is also governed by our Privacy Policy, which explains how we collect, use, and
safeguard personal information.<br/>
8. Disclaimers
The Portal is provided 'as is' without warranty. Definite Assurance does not guarantee uninterrupted
or error-free service.<br/>
9. Limitation of Liability
Definite Assurance shall not be liable for any damages arising out of use or inability to use the
Portal.<br/>
10. Termination of Access
Definite Assurance may suspend or terminate access at any time, with or without cause.<br/>
11. Third-Party Links
The Portal may contain links to third-party websites. Definite Assurance is not responsible for their
content or practices.<br/>
12. Changes to the Terms
Definite Assurance Company Ltd | info@definiteassurance.com | digital.definiteassurance.com
We may update these Terms at any time. Continued use constitutes acceptance of updated Terms.<br/>
13. Governing Law
These Terms shall be governed by the laws of the Republic of Kenya.<br/>
14. Contact Information
Definite Assurance Company Ltd | info@definiteassurance.com | Regulated by Insurance
Regulatory Authority (IRA), Kenya.
        </p>
    </div>
  )
}
